import { atom } from 'jotai';

export const editingOffsetsAtom = atom(false);
editingOffsetsAtom.debugLabel = 'editingOffsets';

export const editingSourceDataAtom = atom(false);
editingSourceDataAtom.debugLabel = 'editingSourceData';

export const offsetDataIsUpdatingAtom = atom(false);
offsetDataIsUpdatingAtom.debugLabel = 'offsetDataIsUpdating';
